export const AnonymousMapUsername = 'alltrails-guest-maps';
export const PaymentDisplayText = 'AllTrails+';
export const XLATE_NONE = 'xlate-none';
export const XLATE_GOOGLE = 'xlate-google';
